<template>
    <div class="agent-page">
        <div style="display: flex; align-items: center; justify-content: space-between;">
            <div style="display: flex; flex-direction: column; text-align: start;">
                  <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" >中标公告</h2>
            </div>
            <div style="display: flex; align-items: center; gap: 10px;">
                  <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加中标公告</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
              
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <el-table :data="tableData" v-loading="loading" border style="width: 100%" class="data-table">
                <el-table-column prop="no" label="NO." width="60" align="center" />
                <el-table-column prop="winBulletinCode" label="公告编码" show-overflow-tooltip />
                <el-table-column prop="winBulletinName" label="公告名称" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="winningBidderName" label="中标单位名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div v-if="scope.row.winBidderList && scope.row.winBidderList.length > 0">
                            <div v-for="(bidder, index) in scope.row.winBidderList" :key="index">
                                {{ bidder.winBidderName }}
                            </div>
                        </div>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="winningBidPrice" label="中标价格(元)" width="150" align="right">
                    <template slot-scope="scope">
                        <div v-if="scope.row.winBidderList && scope.row.winBidderList.length > 0">
                            <div v-for="(bidder, index) in scope.row.winBidderList" :key="index">
                                <span class="price-text">{{ bidder.bidAmount }}</span>
                            </div>
                        </div>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="120" align="center">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" size="small">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <template v-if="scope.row.status == 0 || scope.row.status == 2">
                            <el-button type="text" size="small" @click="handleEdit(scope.row)" class="action-btn">
                                编辑
                            </el-button>
                            <el-button type="text" size="small" @click="handleDelete(scope.row)" class="action-btn" style="color: #f56c6c;">
                                删除
                            </el-button>
                        </template>
                        <template v-else>
                            <el-button type="text" size="small" @click="handleViewDetails(scope.row)" class="action-btn">
                                查看详情
                            </el-button>
                            <el-button v-if="scope.row.status == 9" type="text" size="small" @click="handlePublishChange(scope.row)" class="action-btn">
                                发布变更公告
                            </el-button>
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="pagination.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pagination.total" class="pagination" />
        </div>

    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/bid/projectInfo'
import { winBulletinList, winBulletinDelete } from '@/api/modules/winBulletin'


export default {
    name: 'WinningBidAnnouncement',
    data() {
        return {
            loading: false,
            projectTitle: '',
            projectCode: this.$route.query.projectCode,
            procurementType: this.$route.query.procurementType,
            projectType: this.$route.query.type,
            tableData: [],
            pagination: {
                currentPage: 1,
                pageSize: 10,
                total: 1
            }
        }
    },
    mounted() {
        this.ininPage()

    },
    methods: {
        ininPage() {
            this.pagination.currentPage = 1
            this.getProjectInfo()
            this.getBulletinList()
        },
        async getBulletinList() {
            this.loading = true
            try {
                const response = await winBulletinList({
                    projectCode: this.projectCode,
                    pageNum: this.pagination.currentPage,
                    pageSize: this.pagination.pageSize
                })
                if (response && response.code === 200) {
                    const data = response.data || {}
                    const records = data.records || []
                    this.tableData = records.map((item, index) => ({
                        ...item,
                        no: (this.pagination.currentPage - 1) * this.pagination.pageSize + index + 1
                    }))
                    this.pagination.total = data.total || 0
                } else {
                    this.tableData = []
                    this.pagination.total = 0
                }
            } catch (error) {
                console.error('获取中标公告列表失败:', error)
                this.tableData = []
                this.pagination.total = 0
            } finally {
                this.loading = false
            }
        },
        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },
        //返回上一页
        handleBack() {
            this.$router.go(-1)
        },
        //添加中标公告
        handleAdd() {
            this.$router.push({ path: '/agentHome/addBidNotice', query: { projectCode: this.projectCode, procurementType: this.procurementType, type: this.projectType } })
        },
        //查看详情（只读）
        handleViewDetails(row) {
            this.$router.push({ path: '/agentHome/addBidNotice', query: { projectCode: this.projectCode, winBulletinCode: row.winBulletinCode, procurementType: this.procurementType, type: this.projectType, mode: 'view' } })
        },
        // 编辑（暂存状态）
        handleEdit(row) {
            this.$router.push({ path: '/agentHome/addBidNotice', query: { projectCode: this.projectCode, winBulletinCode: row.winBulletinCode, procurementType: this.procurementType, type: this.projectType, mode: 'edit' } })
        },
        // 发布变更公告（已发布状态）
        handlePublishChange(row) {
            this.$router.push({ path: '/agentHome/addBidNotice', query: { projectCode: this.projectCode, procurementType: this.procurementType, type: this.projectType, mode: 'edit', typeCode: 2, bidSectionCode: row.bidSectionCode, sourceCode: row.winBulletinCode } })
        },
        // 删除
        handleDelete(row) {
            this.$confirm('此操作将删除该中标公告, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true
                winBulletinDelete({
                    winBulletinCode: row.winBulletinCode
                }).then(res => {
                    if (res.code == 200) {
                        this.ininPage()
                    } else {
                        this.$message.error(res.msg)
                    }
                })
                setTimeout(() => {
                    this.loading = false
                }, 400);
            })
        },
        handleSizeChange(val) {
            this.pagination.pageSize = val
            this.pagination.currentPage = 1
            this.getBulletinList()
        },

        handleCurrentChange(val) {
            this.pagination.currentPage = val
            this.getBulletinList()
        },

        getStatusText(status) {
            const statusMap = {
                0: '暂存',
                2: '退回',
                1: '提交',
                9: '发布'
            }
            return statusMap[status] || '未知'
        },

        getStatusType(status) {
            const statusMap = {
                0: 'info',
                2: 'danger',
                1: 'warning',
                9: 'success'
            }
            return statusMap[status] || 'info'
        }
    }
}
</script>

<style lang="less" scoped>
.agent-page {
    padding: 0;
    background-color: transparent;
    min-height: calc(100vh - 64px);

    .page-title {
        font-size: 20px;
        font-weight: 600;
        color: #303133;
        margin: 0;
        position: relative;
        padding-left: 12px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 4px;
            height: 20px;
            background: #409EFF;
            border-radius: 2px;
        }
    }

    /deep/ .el-button {
        border-radius: 4px;
        font-weight: 500;
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 8px rgba(64, 158, 255, 0.3);
        }

        &:active {
            transform: translateY(0);
        }
    }
}

.table-section {
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    margin-top: 20px;
    transition: box-shadow 0.3s ease;

    &:hover {
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    /deep/ .el-table {
        border-radius: 4px;
        overflow: hidden;

        th {
            background: #f5f7fa;
            color: #606266;
            font-weight: 600;
            font-size: 14px;
            padding: 14px 0;
        }

        td {
            padding: 14px 0;
            font-size: 14px;
            color: #606266;
        }

        .el-table__row {
            transition: background-color 0.2s ease;

            &:hover {
                background-color: #f5f7fa;
            }
        }

        .el-button--text {
            padding: 4px 8px;
            font-size: 14px;
            font-weight: 500;
            transition: all 0.2s ease;

            &:hover {
                background: rgba(64, 158, 255, 0.1);
                border-radius: 4px;
            }
        }
    }
}

.pagination-section {
    margin-top: 20px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    display: flex;
    justify-content: flex-end;

    /deep/ .el-pagination {
        .el-pagination__total,
        .el-pagination__jump {
            color: #606266;
            font-weight: 500;
        }

        .btn-prev,
        .btn-next,
        .el-pager li {
            background: transparent;
            border-radius: 4px;
            transition: all 0.2s ease;
            font-weight: 500;

            &:hover {
                background: #f5f7fa;
            }

            &.active {
                background: #409EFF;
                color: #fff;
            }
        }
    }
}

.action-btn {
    color: #409EFF;
    margin-right: 10px;
}

.price-text {
    font-weight: 600;
    color: #e6a23c;
}

@media (max-width: 768px) {
    .pagination-section {
        padding: 12px;
        
        /deep/ .el-pagination {
            .el-pagination__jump {
                margin-left: 0;
            }
        }
    }
}
</style>
